import { setGlobal } from 'hooks/useGlobal';
import { ApolloProvider } from '@apollo/client';

import * as K from 'common/constants';
import RootErrorBoundary from 'components/common/ModernUIErrorBoundary/ModernUIErrorBoundary';
import client from 'api/apolloClient';

import App from 'App';

// initialize reactn global state
setGlobal({ ...K.GLOBAL_DEFAULT });

function PrivateApp(): JSX.Element {
  return (
    <ApolloProvider client={client}>
      <RootErrorBoundary fullHeight>
        <App />
      </RootErrorBoundary>
    </ApolloProvider>
  );
}

export default PrivateApp;
